import React from 'react';
import { ChevronLeft, ChevronRight } from '../icons/icons';

type PaginationControllerProps = {
  pageNumber: number,
  maxPageNumber: number,
  navigateNextPage: () => void,
  navigatePreviousPage: () => void,
}

export const PaginationController = ({
  pageNumber,
  maxPageNumber,
  navigateNextPage,
  navigatePreviousPage,
}: PaginationControllerProps) => (
  <div className='flex items-center justify-center'>
    <div className='inline-flex items-center gap-1 rounded-lg border border-slate-200 bg-white p-1 shadow-sm'>
      <button
          type='button'
          className='inline-flex h-8 items-center gap-1 rounded-md px-2 text-xs font-semibold text-slate-600 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:text-slate-300'
          disabled={pageNumber === 1}
          onClick={navigatePreviousPage}
      >
        <ChevronLeft />
        <span className='hidden sm:inline'>Previous</span>
      </button>
      <div className='flex h-8 min-w-[76px] items-center justify-center rounded-md bg-slate-50 px-3 text-xs font-semibold text-slate-700'>
        { maxPageNumber !== 0 ? pageNumber : 0 } of { maxPageNumber }
      </div>
      <button
          type='button'
          className='inline-flex h-8 items-center gap-1 rounded-md px-2 text-xs font-semibold text-slate-600 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:text-slate-300'
          disabled={pageNumber === maxPageNumber || maxPageNumber === 0}
          onClick={navigateNextPage}
      >
        <span className='hidden sm:inline'>Next</span>
        <ChevronRight />
      </button>
    </div>
  </div>
);
